import "$styles/index.css";
import "$styles/syntax-highlighting.css";

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

import Headroom from "headroom.js";
import { lazyLoad } from "unlazy";

// import Swup from 'swup';
// import SwupFadeTheme from '@swup/fade-theme';
// import SwupSlideTheme from '@swup/slide-theme';
// import SwupPreloadPlugin from '@swup/preload-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin';
// import SwupHeadPlugin from '@swup/head-plugin';
// import SwupA11yPlugin from '@swup/a11y-plugin';

import "@fortawesome/fontawesome-free/js/all.js";

const header = document.querySelector("#navbar");

const headroom = new Headroom(header);
headroom.init();

// Apply lazy loading for all images by the selector `img[loading="lazy"]`
lazyLoad();

// const swup = new Swup({
//   plugins: [
//     new SwupFadeTheme(),
//     new SwupPreloadPlugin(),
//     new SwupHeadPlugin(),
//     new SwupScriptsPlugin({
//       optin: true
//     }),
//     new SwupA11yPlugin()
//   ]
// });
